<template>
  <!-- 日期选择弹窗 -->
  <van-popup v-model="showDatePopup" class="date-popup" position="bottom" get-container="#app">
    <div class="date-popup-tools">
      <div class="tab-item" :class="{ active: dateType == 'year-month' }" @click="typeClick('year-month')">
        按月选择
      </div>
      <div class="tab-item" :class="{ active: dateType == 'date' }" @click="typeClick('date')">
        按日选择
      </div>
      <div class="icon-cha" @click="showDatePopup = false"></div>
    </div>
    <div class="date-box" v-if="dateType == 'date'">
      <div class="date-item" :class="{ active: curDateIndex == 0 }" @click="timeClick(0)">
        {{ sDate | dateFormat("yyyy年MM月dd日") }}
      </div>
      <span>至</span>
      <div class="date-item" :class="{ active: curDateIndex == 1 }" @click="timeClick(1)">
        {{ eDate | dateFormat("yyyy年MM月dd日") }}
      </div>
    </div>
    <van-datetime-picker v-if="astrictToday" v-model="currentDate" :type="dateType" title="选择年月日"
      :min-date="dateType == 'date' && curDateIndex == 1 ? sDate : minDate" :visible-item-count="3"
      :max-date="dateType == 'date' && curDateIndex == 0 ? eDate : maxDate" :show-toolbar="false" @change="dateChange"
      :formatter="formatter" :swipe-duration="100" />

    <van-datetime-picker v-else v-model="currentDate" :type="dateType" title="选择年月日"
      :min-date="dateType == 'date' && curDateIndex == 1 ? sDate : minDate" :visible-item-count="3" :show-toolbar="false"
      @change="dateChange" :formatter="formatter2" :swipe-duration="100" />
    <div class="btn-box">
      <div class="btn" @click="submit">确定</div>
    </div>
  </van-popup>
</template>

<script>
import dayjs from 'dayjs';
export default {
  data() {
    const sDate = new Date();
    sDate.setDate(1);
    return {
      showDatePopup: false, //时间选择面板
      dateType: "year-month",
      curDateIndex: 0,
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(),
      sDate: sDate,
      eDate: new Date(),
      currentDate: sDate,
    };
  },
  props: {
    // dateType: {
    //   type: String,
    //   default: 'year-month',
    // },
    astrictToday: {
      type: Boolean,
      default: true,
    },
    conceal: false,
  },
  mounted() { },
  methods: {
    formatter(type, val) {
      if (type === 'month') {
        return `${val}月`;
      } else if (type === 'day') {
        return `${val}日`;
      } else if (type === 'year') {
        return `${val}年`;
      }
      return val;
    },
    formatter2(type, val) {
      if (type === 'month') {
        return `${val}月`;
      } else if (type === 'day') {
        return `${val}日`;
      } else if (type === 'year') {
        return `${val}年`;
      }
      return val;
    },
    init(type){
      this.dateType = type;
      this.submit('init')
    },
    // 提交数据
    submit(type) {
      if (type == "init") {
        if (this.dateType == "date") {
          this.setStimeAndEtime1();
        }
        if (sessionStorage.appDatePanel_SDate) {
          this.sDate = new Date(sessionStorage.appDatePanel_SDate);
          this.currentDate = this.sDate;
        }
        if (sessionStorage.appDatePanel_EDate) {
          this.eDate = new Date(sessionStorage.appDatePanel_EDate);
        }
        if (sessionStorage.appDatePanel_DateType) {
          this.dateType = sessionStorage.appDatePanel_DateType;
        }

      } else if (this.dateType == "year-month") {
        this.setStimeAndEtime();
      }
      this.showDatePopup = false;
      let sDate = this.$tools.dateFormat(this.sDate, "yyyy-MM-dd");
      let eDate = this.$tools.dateFormat(this.eDate, "yyyy-MM-dd");
      sessionStorage.appDatePanel_SDate = sDate;
      sessionStorage.appDatePanel_EDate = eDate;
      sessionStorage.appDatePanel_DateType = this.dateType;
      this.$emit("submit", [sDate, eDate]);
    },
    // 时间类型点击
    typeClick(type) {
      this.dateType = type;
      if (type == "date") {
        this.setStimeAndEtime();
      }
      this.$nextTick((_) => {
        this.currentDate = this.sDate;
      });
    },
    setStimeAndEtime1() {
      // let curDate = new Date(this.currentDate);
      // curDate.setDate(1);
      this.sDate = new Date(dayjs().subtract(1, 'month'));
      this.eDate = new Date()
      this.$nextTick((_) => {
        this.currentDate = this.sDate;
      });
    },
    // 设置开始结束时间
    setStimeAndEtime() {
      let isCurMonth = false;
      let curDate = new Date(this.currentDate);
      if (
        curDate.getFullYear() == new Date().getFullYear() &&
        curDate.getMonth() == new Date().getMonth()
      ) {
        isCurMonth = true;
      }
      curDate.setDate(1);
      this.sDate = new Date(curDate);
      if (isCurMonth) {
        this.eDate = new Date();
      } else {
        curDate.setMonth(curDate.getMonth() + 1);
        curDate.setDate(0);
        this.eDate = new Date(curDate);
      }
    },
    // 获取当前的开始结束时间
    getStimeAndEtime() {
      this.setStimeAndEtime();
      return [
        this.$tools.dateFormat(this.sDate, "yyyy-MM-dd"),
        this.$tools.dateFormat(this.eDate, "yyyy-MM-dd"),
      ];
    },
    // 开始结束时间点击
    timeClick(i) {
      this.curDateIndex = i;
      // this.$nextTick((_) => {
      //   this.currentDate =  i == 0 ? this.sDate : this.eDate;
      // });
      setTimeout(() => {
        this.currentDate =  i == 0 ? this.sDate : this.eDate;
      },0)
    },
    // 修改筛选时间
    dateChange(e) {
      console.log(e);
      if (this.dateType == "date") {
        if (this.curDateIndex == 0) {
          this.sDate = this.currentDate;
        } else {
          this.eDate = this.currentDate;
        }
      }
    },
    // 关闭
    close() {
      this.showDatePopup = false;
    },
    // 打开
    open() {
      this.showDatePopup = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./datePopup.scss";
</style>
